export default "__VITE_ASSET__3e588080__"